export enum GenerateArticleModalRadioType {
  POOL,
  MANUAL,
  RANDOM,
}
